import moment, { MomentInput } from 'moment'

export const dateFormat = 'MM/DD/YY [at] LT'

export const formatTime = (time: MomentInput, formatString: string) => {
  const momentInTime = moment(time)
  const formattedDateTime = momentInTime.format(formatString)
  return formattedDateTime
}

export const fromNow = (time: MomentInput) => {
  return moment(time).fromNow()
}

export const getCurrentTime = () => Number(moment().format('x'))
